import Notification from '../Notification'

function NotificationsBanner({
  notifications,
  backgroundColor = '#fff',
  setNotifications,
  handleScroll,
  role = '',
}) {
  const removeNotification = (id) => {
    const nots = notifications.filter((not) => not.id !== id)
    setNotifications(nots)
  }

  return (
    <div
      style={{
        backgroundColor: { backgroundColor },
        width: '100%',
        height: '100%',
        padding: 15,
        paddingBottom: 50,
      }}
    >
      <div
        style={{
          height: '100%',
          overflowY: 'scroll',
        }}
        onScroll={(values) =>
          handleScroll({
            scrollTop: values.target.scrollTop,
            scrollHeight: values.target.scrollHeight,
            clientHeight: values.target.clientHeight,
          })
        }
      >
        {notifications?.map((notification, index) => (
          <Notification
            key={index}
            role={role}
            notification={notification}
            buttonText={role === 'attendant' ? '' : 'Marcar como lido'}
            requestId={notification.request_id}
            removeNotification={(id) => removeNotification(id)}
          >
            <span style={{ fontSize: 14 }}>{notification.description}</span>
          </Notification>
        ))}
      </div>
    </div>
  )
}

export default NotificationsBanner
